/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api, asJson } from '../lib/api.js';
import { BETA_FAIL_MSG, PB_URL } from '../lib/config.js';
import { playPop } from '../lib/sound.js';
import { dayKey, nextDayKey } from '../lib/text.js';

export default {
  /**
   * Alleen voor de mod. Het menu toonde de regel al alleen aan hem, maar het adres
   * #mod kwam hier ook langs, en dan kon iedereen berichten sturen die eruitzien
   * alsof ze van de paal komen en de keuze van morgen wissen. Let wel: dit is een
   * slot in de app, geen slot op de server. Dat moeten de API-regels doen.
   */
  openMod() {
      if (!this.isMaintainer) return undefined;
      return this.setState({ dialog: 'mod', notifOpen: false });
    },

  /**
   * Wie mag de spelletjes die nog in beta staan?
   *
   * Dit scherm zet een vinkje op iemands eigen regel in paal_accounts. Daarvoor
   * stond de gastenlijst in de code, en dan moest er voor een tester erbij een
   * nieuwe versie de lucht in.
   *
   * Je komt hier alleen uit het modgereedschap; er is met opzet geen adres voor.
   */
  openBeta() { return this.setState({ dialog: 'beta', betaFout: '', notifOpen: false }, this.fetchAccounts); },

  /** Terug naar het modgereedschap, want daar kwam je vandaan. */
  closeBeta() { return this.setState({ dialog: 'mod', betaFout: '' }); },

  async toggleBeta(id) {
      if (!this.isMaintainer || !PB_URL) return;
      const acc = (this.state.accounts || []).find((a) => a.id === id);
      if (!acc || this.state.betaBezig) return;
      const aan = !acc.beta;
      const zet = (waarde) => this.setState({
        accounts: (this.state.accounts || []).map((a) => (a.id === id ? Object.assign({}, a, { beta: waarde }) : a))
      });
      // Meteen omzetten in beeld, de server volgt. Gaat het mis, dan zet de
      // catch hem terug en staat eronder waarom.
      this.setState({ betaFout: '', betaBezig: id });
      zet(aan);
      try {
        const res = await api(`${PB_URL}/api/collections/paal_accounts/records/${id}`, asJson('PATCH', { beta: aan }));
        if (!res.ok) throw new Error(String(res.status));
        const rec = await res.json();
        // PocketBase gooit een veld dat het niet kent zonder te klagen weg en geeft
        // een nette 200 terug. Je merkt dat dus alleen door terug te lezen wat er
        // echt in de regel staat. Dezelfde controle als bij pinHash in
        // logic/account-save.js.
        if (!!rec.beta !== aan) throw new Error('veld');
        this.setState({ betaBezig: '' });
        playPop();
      } catch (e) {
        zet(!aan);
        this.setState({
          betaBezig: '',
          betaFout: e.message === 'veld' ? BETA_FAIL_MSG : 'Opslaan mislukt (' + e.message + ').'
        });
      }
    },

  openGuestbook() {
      this.vensterNaarVoren('gastenboek');
      return this.setState({ gbOpen: true, vensterMin: Object.assign({}, this.state.vensterMin, { gastenboek: false }), notifOpen: false, startOpen: false, gbUsed: this.gbQuota() },
        () => this.fetchGuestbook());
    },


  closeGuestbook() { this.gbHoverOut(); this.setState({ gbOpen: false, vensterMin: Object.assign({}, this.state.vensterMin, { gastenboek: false }) }); },

  // Krabbel van de dag: de mod mag kiezen uit drie voorstellen. Kiest hij niets,
  // dan blijft de paal zelf kiezen (vaste keuze per dag).
  openDailyPicker() { return this.setState({ dialog: 'dailyPick', notifOpen: false }, () => this.fetchDailyPick()); },

  async fetchDailyPick(silent) {
      if (!PB_URL) return;
      try {
        const res = await api(`${PB_URL}/api/collections/paal_daily/records?sort=-day&perPage=500`);
        if (!res.ok) { this.setState({ dailyPickStatus: res.status }); return; }
        const data = await res.json();
        const items = data.items || [];
        const rec = items.find((r) => r.day === dayKey()) || null;
        const next = items.find((r) => r.day === nextDayKey()) || null;
        // Alles wat t/m vandaag al krabbel van de dag was, valt uit het keuzemenu.
        const used = items.filter((r) => r.drawingId && r.day && r.day <= dayKey()).map((r) => r.drawingId);
        this.recordAutoDailyIfNeeded(rec);
        if (!silent || JSON.stringify([rec, next, used]) !== JSON.stringify([this.state.dailyRec, this.state.dailyNext, this.state.dailyUsed])) {
          this.setState({ dailyRec: rec, dailyNext: next, dailyUsed: used, dailyPickStatus: 0 });
        }
      } catch (e) {}
    },

  // Als de mod niets kiest, wijst de paal zelf een krabbel aan. Die auto-keuze
  // wordt ook vastgelegd. Hier stond een letterlijke kopie van de som in
  // logic/gallery.js; twee kopieën lopen vroeg of laat uit elkaar.
  getAutoDaily() { return this.dagKeuze().zelf; },

  async recordAutoDailyIfNeeded(recToday) {
      if (!this.isMaintainer || !PB_URL) return;
      const today = dayKey();
      if (recToday && recToday.day === today) return;
      if (this._autoDailyChecked === today) return;
      const auto = this.getAutoDaily();
      if (!auto) return;
      this._autoDailyChecked = today;
      try {
        const res = await api(`${PB_URL}/api/collections/paal_daily/records`, asJson('POST', { day: today, drawingId: auto.id, pickedBy: '' }));
        if (res.ok) this.fetchDailyPick(true);
      } catch (e) {}
    },

  async setDailyPick(id) {
      if (!this.isMaintainer || !PB_URL) return;
      playPop();
      const rec = this.state.dailyNext;
      this.setState({ dailyNext: Object.assign({}, rec || {}, { day: nextDayKey(), drawingId: id, pickedBy: this.state.author || '' }), dialog: 'mod' });
      try {
        const data = { day: nextDayKey(), drawingId: id, pickedBy: this.state.author || '' };
        const res = rec && rec.id
          ? await api(`${PB_URL}/api/collections/paal_daily/records/${rec.id}`, asJson('PATCH', data))
          : await api(`${PB_URL}/api/collections/paal_daily/records`, asJson('POST', data));
        if (!res.ok) throw new Error(res.status);
        this.notify('De krabbel van morgen staat vast.');
        this.fetchDailyPick(true);
      } catch (e) {
        this.notify('Kiezen mislukt (' + e.message + '). Maak in PocketBase een collectie “paal_daily” met tekstvelden day, drawingId en pickedBy.');
      }
    },

  async clearDailyPick() {
      if (!this.isMaintainer) return;
      const rec = this.state.dailyNext;
      this.setState({ dailyNext: null, dialog: 'mod' });
      if (!rec || !rec.id || !PB_URL) return;
      try { await api(`${PB_URL}/api/collections/paal_daily/records/${rec.id}`, { method: 'DELETE' }); } catch (e) {}
      this.notify('De paal kiest morgen weer zelf.');
      this.fetchDailyPick(true);
    }
};
